import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useFunctionResult } from 'record-it-components/hooks/useFunctionResult/useFunctionResult';
import { EntityName } from 'record-it-time-common/EntityName';
import { ArrayUtils } from 'record-it-utils/utils/ArrayUtils/ArrayUtils';
import { useEntityChangedListener } from '../useEntityChangedListener/useEntityChangedListener';
import { useEntityRepository } from '../useEntityRepository';

export function useTimeTrackingActivityPathName(
  timeTrackingActivityId: string | null
): string | null {
  const repository = useEntityRepository(EntityName.TimeTrackingActivity);

  const { t } = useTranslation();

  const wrappedFunction = useCallback(
    (idParam: string | null) => {
      return idParam ? repository.getPath(idParam) : null;
    },
    [repository]
  );

  const { result: path, update } = useFunctionResult({
    func: wrappedFunction,
    funcArgs: [timeTrackingActivityId],
    resultsAreEqual: (a, b) => {
      return a != null && b != null && ArrayUtils.areShallowEqual(a, b);
    }
  });

  useEntityChangedListener(EntityName.TimeTrackingActivity, update);

  return path
    ? path
        .map((a) => {
          if (!a) {
            return t('hooks.entity.timeTrackingActivity.unknownActivity');
          }

          return a.name;
        })
        .join(' - ')
    : null;
}
